import VueI18n from "vue-i18n";
import Vue from "vue";
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";

Vue.use(VueI18n);

const i18n = new VueI18n({
  // locale: localStorage.getItem("language") || LOCALE,
  locale: LOCALE,
  fallbackLocale: "en-US",
  messages: {
    "en-US": { ...require("@/locales/en.json"), ...enLocale },
    "zh-CN": { ...require("@/locales/cn.json"), ...zhLocale },
  },
});
locale.i18n((key, value) => i18n.t(key, value)); //重点：为了实现element插件的多语言切换

export default i18n;
